import classNames from 'classnames';
import React from 'react';
import { usePatchedDropdownMenu } from '../utils/usePatchedDropdownMenu';

type Props = {
    currentLanguage: string;
    changeLanguageClicked: (lang: string) => void;
};

const supportedLanguages = [
    { langCode: 'nl', langName: 'NL (Nederlands)' },
    { langCode: 'en', langName: 'EN (English)' },
];
const itemsInMenu = supportedLanguages.length;

export function LanguageDropdownMenu(props: Props) {
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(itemsInMenu);
    const classes = classNames('navbar-btn btn-group', { open: isOpen });

    const onItemClick = (langCode: string) => {
        setIsOpen(false);
        props.changeLanguageClicked(langCode);
    };

    return (
        <li className="dropdown menu-merge">
            <div className={classes}>
                <button {...buttonProps} className="btn btn-sm dropdown-toggle" data-toggle="dropdown" type="button">
                    {props.currentLanguage}
                </button>
                <ul role="menu" className="dropdown-menu pv5 animated animated-short fadeIn">
                    {supportedLanguages.map((langObj, index) => (
                        <li {...itemProps[index]} key={index} onClick={() => onItemClick(langObj.langCode)}>
                            <a className="cursor">{langObj.langName}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    );
}
